/* eslint-disable @typescript-eslint/naming-convention, no-underscore-dangle, id-denylist, id-match */

import { Component, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { SchemaField, Document, NumberFormat, DocumentSchema, SystemFieldType } from '../../../store/models/document.model';
import { DynamicField } from '../dynamic-field';
import { TranslateService } from '@ngx-translate/core';
import { ViewComponent } from '../../../store/models/workflow.model';
import { DocumentReader } from '../../../store/models';
import { Dataset } from 'src/app/modules/core/store/models/dataset.model';
import { CultureService } from '../../../services/culture.service';

@Component({
    selector: 'app-number-field',
    templateUrl: './number-field.component.html',
    styleUrls: ['./number-field.component.scss'],
    standalone: false
})
export class NumberFieldComponent implements DynamicField, OnDestroy {
  NumberFormat = NumberFormat;
  @Output() valueChanged = new EventEmitter<DynamicField>();
  @Input() field: SchemaField;
  @Input() displayName: string;
  @Input() layerUId: string;
  @Input() set document(value: Document) {
    this.reader = new DocumentReader(value);
  }
  reader: DocumentReader;
  @Input() viewComponent: ViewComponent;
  isReadOnly: boolean;
  @Input() schema: DocumentSchema;
  @Input() dataset: Dataset;

  numberValue: any;
  format: string;
  numberFormat: string;

  showFieldAsEdit: boolean = false;
  private _isEdit: boolean = false;
  @Input() set isEdit(edit: boolean) {
    this._isEdit = edit;

    this.calculateShouldDisplayFieldForEdit();
  }

  calculateShouldDisplayFieldForEdit() {
    this.showFieldAsEdit = this._isEdit && !this.isReadOnly;
  }

  get value(): any {
    if (!!!this.numberValue) {
      this.numberValue = 0;
    }

    if (this.field?.settings?.format === NumberFormat.Number) {
      return parseInt(this.numberValue, 10);
    } else if (this.field?.settings?.format === NumberFormat.Decimal) {
      return this.cultureService.localeParseFloat(this.numberValue);
    } else if (this.field?.settings?.format === NumberFormat.Accounting) {
      return this.cultureService.localeParseFloat(this.numberValue);
    } else {
      return this.cultureService.localeParseFloat(this.numberValue);
    }
  }
  set value(val: any) {
    if (isNaN(val) || val === null) {
      if (!isNaN(this.field?.settings?.defaultValue)) {
        val = this.field?.settings?.defaultValue;
      }
    }

    if (!this.field?.settings?.format) {
      this.numberFormat = NumberFormat.Decimal;
    } else {
      this.translate.get(`FORMAT.${this.format}-FORMAT`).subscribe((res: string) => (this.numberFormat = res));
    }

    this.numberValue = this.cultureService.getNumberDisplay(val, this.format);
  }

  get formattedValue() {
    return this.reader?.getFormattedFieldValue(this.field?.systemName, this.field, this.cultureService);
  }

  constructor(private translate: TranslateService, private cultureService: CultureService) {}

  ngOnDestroy(): void {
    this.valueChanged.complete();
  }

  tpOnContentUpdated(): void {
    this.format = this.field?.settings?.format;
    this.translate.get(`FORMAT.${this.format}-FORMAT`).subscribe((res: string) => (this.numberFormat = res));

    this.value = this.reader.getFieldValue(this.field.systemName);

    if ((this.field.fieldType & SystemFieldType.Editable) !== SystemFieldType.Editable || this.viewComponent?.configuration?.isReadOnly) {
      this.isReadOnly = true;
      this.calculateShouldDisplayFieldForEdit();
    }
  }

  numberFieldChange(elm: any): void {
    this.numberValue = this.cultureService.getNumberDisplay(this.value, this.format);

    this.onValueChanged();
  }

  onValueChanged(): void {
    this.valueChanged.emit(this);
  }
}
